import type { RaRecord } from "react-admin";

type HallBookingWithName = { hall?: { name?: string | null } | null };

/** Unique hall names for a receipt's linked booking, comma-separated. */
export function formatBookingHallNames(rec: RaRecord | null | undefined): string {
  const hallsRaw = (rec?.booking as { hallBookings?: HallBookingWithName[] } | undefined)
    ?.hallBookings;
  const names = [
    ...new Set(
      (hallsRaw ?? []).map((hb) => hb.hall?.name?.trim()).filter((n): n is string => Boolean(n))
    ),
  ];
  return names.join(", ");
}
